import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    icon: {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
      }),

      '&.open': {
        transform: 'rotate(180deg)',
      },
    },
    paper: {
      zIndex: 10000,
    },
    activeIndicator: {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
    label: {
      textTransform: 'none',
      fontSize: theme.typography.pxToRem(14),
    },
    tooltipPaper: {
      padding: 0,
      minWidth: 'fit-content',
      '-webkit-font-smoothing': 'antialiased !important',
    },
  }),
);
